import { initCartDrawerItemActions } from './cart_drawer_items.js';
import { initCartDrawerSuggestionActions } from './cart_drawer_suggestions.js';
import { initCartDrawerGiftActions } from './cart_drawer_gifts.js';
import { initCartDrawerShippingActions } from './cart_drawer_shipping.js';

export function initCartDrawerActions({ getDrawer, setLoading, load, qty_errors, openAfterAdd, drawerSelector = '#cart-drawer' }) {
    initCartDrawerItemActions({ getDrawer, setLoading, load, qty_errors, drawerSelector });
    initCartDrawerSuggestionActions({ openAfterAdd, drawerSelector });
    initCartDrawerGiftActions({ setLoading, load, drawerSelector });
    initCartDrawerShippingActions({ getDrawer, drawerSelector });
}
